import { Api, Codes } from 'api';
export default {
  state: () => ({
    countries: [],
    states: {},
    cities: {},
    zones: {}
  }),
  mutations: {
    setCountries(state, payload) {
      if (payload.promise) {
        state.countries = payload.promise;
      } else {
        state.countries = payload?.data || [];
      }
    },
    setStates(state, payload) {
      const id = payload?.countryId || '';
      if (payload.promise) {
        state.states[id] = payload.promise;
      } else {
        state.states[id] = payload?.data || [];
      }
    },
    setCities(state, payload) {
      const id = payload?.stateId || '';
      if (payload.promise) {
        state.cities[id] = payload.promise;
      } else {
        state.cities[id] = payload?.data || [];
      }
    },
    setZones(state, payload) {
      const id = payload?.cityId || '';
      if (payload.promise) {
        state.zones[id] = payload.promise;
      } else {
        state.zones[id] = payload?.data || [];
      }
    }
  },
  actions: {
    getCountries: ({ commit, state }) => {
      let memory = state.countries;
      if (memory instanceof Promise) {
        return memory;
      } else {
        if (memory.length) {
          return new Promise(resolve => {
            resolve(memory);
          });
        } else {
          let promise = new Promise(resolve => {
            let ret = [];
            if (memory.length) {
              resolve(memory);
            } else {
              Api.get.getCountries().then(res => {
                if (res.status === Codes.SUCCESS && res.data) {
                  ret = res.data;
                  commit('setCountries', { data: ret });
                  resolve(ret);
                } else {
                  resolve(ret);
                }
              });
            }
          });
          commit('setCountries', { promise });
          return promise;
        }
      }
    },
    getStates: ({ commit, state }, id = 1) => {
      let memory = state.states[id];
      if (memory instanceof Promise) {
        return memory;
      } else {
        if (memory?.length) {
          return new Promise(resolve => {
            resolve(memory);
          });
        } else {
          let promise = new Promise(resolve => {
            let ret = [];
            if (memory?.length) {
              ret = memory;
              resolve(memory);
            } else {
              Api.get
                .getStates({
                  country_id: id
                })
                .then(res => {
                  if (res.status === Codes.SUCCESS && res.data) {
                    ret = res.data;
                    commit('setStates', { countryId: id, data: ret });
                    resolve(ret);
                  } else {
                    resolve(ret);
                  }
                });
            }
          });
          commit('setStates', { countryId: id, promise });
          return promise;
        }
      }
    },
    getCities: ({ commit, state }, id) => {
      let memory = state.cities[id];
      if (memory instanceof Promise) {
        return memory;
      } else {
        if (state.cities[id]?.length) {
          return new Promise(resolve => {
            resolve(state.cities[id]);
          });
        } else {
          let promise = new Promise(resolve => {
            let ret = [];
            if (state.cities[id]?.length) {
              ret = state.cities[id];
              resolve(state.cities[id]);
            } else {
              Api.get
                .getCities({
                  state_id: id
                })
                .then(res => {
                  if (res.status === Codes.SUCCESS && res.data) {
                    ret = res.data;
                    commit('setCities', { stateId: id, data: ret });
                    resolve(ret);
                  } else {
                    resolve(ret);
                  }
                });
            }
          });
          commit('setCities', { stateId: id, promise });
          return promise;
        }
      }
    },
    getZones: ({ commit, state }, id) => {
      let memory = state.zones[id];
      if (memory instanceof Promise) {
        return memory;
      } else {
        if (state.zones[id]?.length) {
          return new Promise(resolve => {
            resolve(state.zones[id]);
          });
        } else {
          let promise = new Promise(resolve => {
            let ret = [];
            if (state.zones[id]?.length) {
              ret = state.zones[id];
              resolve(state.zones[id]);
            } else {
              Api.get
                .getZones({
                  city_id: id
                })
                .then(res => {
                  if (res.status === Codes.SUCCESS && res.data) {
                    ret = res.data;
                    commit('setZones', { cityId: id, data: ret });
                    resolve(ret);
                  } else {
                    resolve(ret);
                  }
                });
            }
          });
          commit('setZones', { cityId: id, promise });
          return promise;
        }
      }
    }
  }
};
